<template>
  <div class="date-picker-header">
    <VueCtkDateTimePicker
      v-model="localDateRange"
      range
      only-date
      label="Select date"
      no-clear-button
      :custom-shortcuts="customShortcuts"
      :first-day-of-week="1"
      no-value-to-custom-elem
      output-format="YYYY-MM-DD"
      :max-date="maxDate"
      :shortcut="shortcut"
      auto-close
      right
      color="#000000"
    >
      <template #default="{ toggleDatePicker }">
        <div class="date-container" @click="toggleDatePicker(true)">
          <div class="input-container">
            <span v-if="showDropdownLabelValue" class="title">Select date</span>
            <span class="date-string">{{ formatDateString }}</span>
          </div>
          <el-icon size="16">
            <ArrowDown />
          </el-icon>
        </div>
      </template>
    </VueCtkDateTimePicker>
  </div>
</template>
<script lang="ts">
import { ArrowDown } from '@element-plus/icons-vue'
import moment from 'moment'

export default {
  name: 'Datepicker',
  components: { ArrowDown },
  // eslint-disable-next-line vue/require-prop-types
  props: ['dateRange', 'shortcut', 'showAllTimeShortcut', 'allTimeStartDate', 'onUpdate', 'showDropdownLabel'],
  data() {
    return {
      localDateRange: this.dateRange,
      maxDate: moment().format('YYYY-MM-DD'),
      lastFetchedDate: null,
      customShortcuts: [
        {
          key: 'last7Days',
          label: 'Last 7 days',
          value: 7,
        },
        {
          key: 'last30Days',
          label: 'Last 30 days',
          value: 30,
        },
        {
          key: 'lastMonth',
          label: 'Last month',
          value: '-month',
        },
        {
          key: 'thisMonth',
          label: 'This month',
          value: moment().date() - 1,
          callback: () => {
            // @ts-expect-error todo fix me
            this.localDateRange = { ...this.localDateRange, key: 'thisMonth' }
          },
        },
        {
          key: 'lastYear',
          label: 'Last year',
          value: '-year',
        },
        {
          key: 'thisYear',
          label: 'This year',
          value: moment().dayOfYear(),
        },
        ...(this.showAllTimeShortcut && this.allTimeStartDate
          ? [
              {
                key: 'All',
                label: 'All time',
                value: () => {
                  return {
                    start: moment(this.allTimeStartDate),
                    end: moment(),
                  }
                },
                callback: () => {
                  // @ts-expect-error todo fix me
                  this.localDateRange = { ...this.localDateRange, allTime: true }
                },
              },
            ]
          : []),
      ],
    }
  },
  computed: {
    showDropdownLabelValue() {
      return this.showDropdownLabel ?? true
    },
    formatDateString() {
      if (this.localDateRange?.allTime) {
        return 'All time'
      }

      if (this.localDateRange?.key) {
        return this.customShortcuts.find((item) => item.key === this.localDateRange.key)?.label
      }

      if (this.localDateRange?.shortcut) {
        return this.customShortcuts.find((item) => item.value === this.localDateRange.shortcut)?.label
      }

      const start = moment(this.localDateRange.start).format('MMM D YYYY')
      const end = this.localDateRange.end ? moment(this.localDateRange.end).format('MMM D YYYY') : '...'
      return `${start} - ${end}`
    },
  },
  watch: {
    localDateRange(newValue, oldValue) {
      const { start, end, shortcut, allTime } = newValue
      if (allTime) {
        return !oldValue?.allTime && this.onUpdate(newValue)
      }
      if (!!start && !!end) {
        const selectedStartDate = moment(start)
        const selectedEndDate = moment(end)
        const dateFormat = 'YYYY-MM-DD'
        this.onUpdate({
          start: selectedStartDate.format(dateFormat),
          end: selectedEndDate.format(dateFormat),
          shortcut,
          key: shortcut && this.customShortcuts.find((item) => item.value === shortcut)?.key,
        })
      }
    },
  },
}
</script>
<style scoped lang="scss">
.date-time-picker:has(.visible) .date-container {
  box-shadow: 0 0 0 1px var(--primary) inset;
}
.date-container {
  min-width: 190px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  color: #252423;
  padding: 6px 16px;
  border-radius: 8px;
  border: 1px solid #dcdfe6;
}
.date-string {
  font-size: 16px;
  line-height: 24px;
  margin-right: 10px;
  white-space: nowrap;
}
.input-container {
  display: flex;
  flex-direction: column;
}
.title {
  color: #000000;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  place-self: flex-start;
}
</style>
